import ServiceWorldNewCase from "@/src/components/Serviceworld/ServiceWorldNewCase";
import React from "react";
import Typography from "@mui/material/Typography";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { useFlexServiceLayoutForCustomer } from "@/src/services/advocardService";
import { Navigate } from "react-router";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

const ServiceWorldNewCasePage = () => {
  const { customer } = useCustomer();

  if (useFlexServiceLayoutForCustomer(customer)) {
    return <Navigate replace to="/servicewelt" />;
  }

  return (
    <LayoutAuthenticated>
      <Typography component={"h1"} variant={"h5"}>
        <strong>Neuen Fall Anlegen</strong>
      </Typography>
      <Typography sx={{ marginBottom: "2rem" }}>
        Wobei benötigen Sie rechtliche Unterstützung? Wählen Sie das Thema, das am besten zu Ihrem Anliegen passt.
      </Typography>
      <ServiceWorldNewCase />
    </LayoutAuthenticated>
  );
};

export default ServiceWorldNewCasePage;
